import { useState } from 'react';

import useExplorerPaylaod from '@/features/InsightExplorer/hooks/useExplorerPaylaod';
import {
  type InsightExplorerFieldType,
  InsightExplorerTrendViewType,
} from '@/features/InsightExplorer/types/constants';
import type { InsightExplorerTrendResponse } from '@/features/InsightExplorer/types/types';
import useInsightExplorerStore from '@/stores/InsightExplorerStore';

import CardContainer from '../CardContainer';
import TotalVolumeTrendSection from './TotalVolumeTrendSection';

interface Props {
  data: InsightExplorerTrendResponse;
  field: InsightExplorerFieldType;
  node_alias: string;
}

const TotalVolumeTrendContainer = (props: Props) => {
  const { data, field } = props;
  const { view, dateState, selectedNode, findNode } = useInsightExplorerStore();
  const { filterPayload } = useExplorerPaylaod();
  const [trendViewType, setTrendViewType] = useState(
    InsightExplorerTrendViewType.NEGATIVE_VOLUME,
  );

  if (!data) return null;
  if (!data?.[0]) return null;
  if (!selectedNode) return null;

  return (
    <CardContainer>
      <TotalVolumeTrendSection
        trendViewType={trendViewType}
        data={data}
        view={view}
        viewType={dateState.rangeUnit}
        field={field}
        filterPayload={filterPayload}
        selectedNode={selectedNode}
        onTrendViewTypeChange={setTrendViewType}
        findNode={findNode}
      />
    </CardContainer>
  );
};

export default TotalVolumeTrendContainer;
